import React from 'react';

// True overlay modal: fixed, full viewport, scrim with blur per Okoyl design.
// Children scroll internally if they overflow. Close on Esc or backdrop click.

class Modal extends React.Component {
    componentDidMount() {
        document.addEventListener('keydown', this.handleKey);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKey);
    }

    handleKey = (event) => {
        const { onLeave } = this.props;
        if (!onLeave) return;
        // Esc (27) or Backspace (8) closes — keep the original Backspace shortcut.
        if (event.keyCode === 27 || event.keyCode === 8) {
            onLeave();
        }
    };

    handleBackdropClick = (event) => {
        if (event.target === event.currentTarget && this.props.onLeave) {
            this.props.onLeave();
        }
    };

    render() {
        const { onLeave, children } = this.props;
        return (
            <div
                onClick={this.handleBackdropClick}
                style={{
                    position: 'fixed',
                    inset: 0,
                    background: 'rgba(7, 6, 10, 0.85)',
                    backdropFilter: 'blur(6px)',
                    WebkitBackdropFilter: 'blur(6px)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 'var(--space-5)',
                    overflowY: 'auto',
                }}
            >
                <div
                    style={{
                        position: 'relative',
                        maxWidth: 920,
                        width: '100%',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {onLeave && (
                        <button
                            type="button"
                            onClick={onLeave}
                            aria-label="✕"
                            style={{
                                position: 'absolute',
                                top: 12,
                                right: 12,
                                zIndex: 2,
                                width: 32,
                                height: 32,
                                background: 'var(--ash-900)',
                                color: 'var(--ash-300)',
                                border: '1px solid rgba(200,144,42,0.32)',
                                borderRadius: 'var(--r-pill)',
                                fontFamily: 'var(--font-display)',
                                fontSize: 14,
                                lineHeight: 1,
                                cursor: 'pointer',
                                transition: 'all var(--dur-2) var(--ease-out)',
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.color = 'var(--okoyl-200)';
                                e.currentTarget.style.borderColor = 'var(--okoyl-400)';
                                e.currentTarget.style.boxShadow = '0 0 12px rgba(200,144,42,0.35)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.color = 'var(--ash-300)';
                                e.currentTarget.style.borderColor = 'rgba(200,144,42,0.32)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            ✕
                        </button>
                    )}
                    {children}
                </div>
            </div>
        );
    }
}

export default Modal;
